/* eslint-disable @typescript-eslint/dot-notation */
import { Inject, Injectable } from '@angular/core';
import { StateService } from '@features/state/state.service';
import { WINDOW } from '@lib/browser/window-providers';
import { IPayload } from './i-payload';
import { TagManagerEvent } from './tag-manager-event.type';

@Injectable({ providedIn: 'root' })
export class DataLayerService {
  defaultBase: IPayload = {
    market: 'Global',
    number_of_collections: 0,
    user_organization: 'IKEA Communications AB',
    user_type: 'external',
  };

  constructor(
    @Inject(WINDOW) private window: Window,
    private stateService: StateService,
  ) {}

  get numberOfCollections(): number {
    if (!this.stateService.stateSnapshot) {
      return -1;
    }

    return this.stateService.stateSnapshot.collection.listOfCollections.length;
  }

  push(event: TagManagerEvent, val: any) {
    const values = {
      ...this.defaultBase,
      number_of_collections: this.numberOfCollections,
      ...val,
      event,
    };
    if (this.window['dataLayer']) {
      this.window['dataLayer'].push(values);
    }
  }
}
